import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import createHugeiconSingleton from '../create-hugeicon-singleton.js';

const HugeiconsIcon = (props) => {
    // Create the component once and memoize it based on the icon
    const Component = useMemo(() => createHugeiconSingleton("HugeiconsIcon", props.icon), [props.icon]);
    return jsx(Component, { ...props });
};

export { HugeiconsIcon, HugeiconsIcon as default };
//# sourceMappingURL=HugeiconsIcon.js.map
